import { useQuery } from "react-query";

import { GET_LIST_OF_DIAGNOSIS, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getListOfDiagnosis } from "api/customers";

const useGetListOfDiagnosis = (clientId) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_LIST_OF_DIAGNOSIS],
    () => getListOfDiagnosis(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      refetchOnWindowFocus: false,
      enabled: Boolean(clientId),
    }
  );

  return {
    listOfDiagnosis: data?.data || null,
    listOfDiagnosisLoading: isLoading,
    refetchListOfDiagnosis: refetch,
    ...rest,
  };
};

export default useGetListOfDiagnosis;
